import React, { useState } from 'react';
import './accordion.css';
import { ChevronDownIcon, ChevronUpIcon } from '../../../content/svg-component';

const Accordion = ({
  children,
  id,
  title,
  classTitle,
  classAccordion,
  classContainer,
  classChildren,
  icon,
  checkStatus = false,
}) => {
  const [isOpen, setIsOpen] = useState(checkStatus);
  return (
    <div className={` text-start ${classContainer}`}>
      <div
        className={`w-100  d-flex flex-column bg-white border py-2 px-3  accordion-item ${classAccordion} ${
          isOpen ? 'accordion__expanded' : ''
        }`}
        id={id}
        onClick={() => setIsOpen((is) => !is)}
      >
        <div className="w-100 d-flex  justify-content-between mt-2">
          <div className="d-flex align-items-center">
            <span className="">{icon}</span>
            <h5 className={`${classTitle} m-0 mx-1`}>{title}</h5>
          </div>
          <span className="">
            {isOpen ? (
              <ChevronUpIcon size={20} />
            ) : (
              <ChevronDownIcon size={20} />
            )}
          </span>
        </div>
        <div
          className={`w-100  accordion-item__content ${
            isOpen && classChildren
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
